import { type FC } from 'react';

// Иконка из дизайна — стилизованный «бегущий человек». Используется как
// универсальный CTA-индикатор «перейти в сцену»: в чате и main-, и
// inside-баннеры рендерят одну и ту же иконку. Цвет stroke наследуется
// от родительской кнопки через `currentColor`, чтобы корректно
// перекрашиваться в светлой/тёмной теме.
export const PersonSimpleRunIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.5 5C5.67157 5 5 4.32843 5 3.5C5 2.67157 5.67157 2 6.5 2C7.32843 2 8 2.67157 8 3.5C8 4.32843 7.32843 5 6.5 5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 6.60015C12.5 6.60015 10.5 4.99578 7.5 7.03765C4.34562 9.1814 2.5 8.34078 2.5 8.34078"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.08594 10.0723C7.97156 10.3123 5.00094 11.2498 5.00094 14.4998"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5975 6.96973C7.97687 8.45285 9.82438 12.9179 14 12.5004"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
